import { getSsoMode, type SsoMode } from "@src/appV2/Auth/RipplingSso/getSsoMode";
import { startSsoRedirect } from "@src/appV2/Auth/RipplingSso/startSsoRedirect";
import { APP_V2_APP_EVENTS, logError } from "@src/appV2/lib/analytics";
import { showErrorToast } from "@src/appV2/lib/Notifications";
import { useCallback } from "react";
import { useTu } from "@src/appV2/i18n/useTu";

type SsoSource = "submit" | "sso_button";

interface UseSsoLoginResult {
  ssoMode: SsoMode;
  handleSsoRedirect: (source: SsoSource) => Promise<void>;
}

export function useSsoLogin(email: string): UseSsoLoginResult {
  const { tu } = useTu("login");
  // SSO is enforced for non-aliased, non-vendor CBH employee emails.
  const ssoMode = getSsoMode(email);

  const handleSsoRedirect = useCallback(
    async (source: SsoSource) => {
      try {
        const requestedURL = localStorage.getItem("redirectURL") ?? undefined;
        await startSsoRedirect(requestedURL, { ssoMode, source });
      } catch (error) {
        logError(APP_V2_APP_EVENTS.RIPPLING_SSO_REDIRECT_FAILURE, { error });
        showErrorToast(tu("Unable to start SSO sign-in. Please try again."));
      }
    },
    [ssoMode, tu]
  );

  return { ssoMode, handleSsoRedirect };
}
